"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditAgreementArtifactWireSchema = exports.CreditAgreementFullArtifactWireSchema = exports.CreditAgreementDocumentWireSchema = exports.creditAgreementSourceDocumentMetadataKeys = exports.CreditAgreementMetadataSchema = exports.CreditAgreementSchemaVersion = exports.CreditAgreementSchemaVersionIterable = exports.BaseFacilityMechanicsSchema = exports.OvercollateralizationMethod = exports.OvercollateralizationMethodIterable = exports.AutoApprovalStrategy = exports.AutoApprovalStrategyIterable = exports.CalcAgentMechanicsWireSchema = exports.MultiLoanProductConcentrationLimitSchema = exports.LoanProductMechanicsSchema = exports.OvercollateralizationAmountPropertySchema = exports.BasePropertyContainerSchema = exports.PropertyContainerType = exports.PropertyContainerTypeIterable = exports.LinkedAccountPropertySchema = exports.ReportingMechanicsSchema = exports.ReportingPropertySchema = exports.ReportConfigTypeIterable = exports.ConcentrationLimitPropertySchema = exports.PortfolioCovenantPropertySchema = exports.FinancialCovenantPropertySchema = exports.PurchasePercentageRatePropertySchema = exports.ReceivableValuationRatePropertySchema = exports.ReceivableAdvanceRatePropertySchema = exports.EligibilityTestPropertySchema = exports.DeliverableReportPropertySchema = exports.TextPropertySchema = exports.StructurePropertySchema = exports.AttachmentRateLimitPropertySchema = exports.PercentageRatePropertySchema = exports.NumberPropertyUnit = exports.NumberPropertyUnitIterable = exports.DeliverablePropertySchema = exports.DeliverableArtifactPropertySchema = exports.CommitmentAmountConfigurationPropertySchema = exports.RecurringDatePropertySchema = exports.DatePropertySchema = exports.CurrencyPropertySchema = exports.CashAdvanceRatePropertySchema = exports.BooleanPropertySchema = exports.BankAccountTypeSchema = exports.BasePropertySchema = exports.PropertyType = exports.PropertyTypeIterable = void 0;
const z = __importStar(require("zod"));
const Bank = __importStar(require("../../Bank"));
const CreditFacility = __importStar(require("../../CreditFacility"));
const Date = __importStar(require("../../Date"));
// Specific import to avoid circular dependency:
// DbTables.ts imports CreditAgreement which includes DomainEntity
const DbTables_1 = require("../../DbTables");
const Deliverable = __importStar(require("../../Deliverable"));
const FundingRequest = __importStar(require("../../FundingRequest"));
const Report = __importStar(require("../../Report"));
const Utils = __importStar(require("../../Utils"));
const Config = __importStar(require("../Config"));
/**
 * NOTE: Credit Agreement Interfaces will shared across multiple services/modules, as it serves as a central
 * configuration for the codebase.  In general, we don't want to export types/interfaces from FinleyTypes,
 * as they can typically be contained by the owner service/module
 */
/**
 * NOTE: This is a temporary home for portions CreditAgreement Domain Entity such that we can
 * more easily refactor concentration limit calculation.
 * Once fully migrated to PG, this should moved back to credit-agreements module
 */
exports.PropertyTypeIterable = [
    'autoApprovalProperty',
    'attachmentRateLimitProperty',
    'bankAccountTypeProperty',
    'booleanProperty',
    'cashAdvanceRateProperty',
    'classAllocationMethodProperty',
    'classLabelProperty',
    'commitmentAmountConfigurationProperty',
    'concentrationLimitProperty',
    'currencyProperty',
    'dateProperty',
    'deliverableReportProperty',
    'deliverableProperty',
    'eligibilityTestProperty',
    'financialCovenantProperty',
    'frequencyPeriodProperty',
    'frequencyProperty',
    'interestRateBenchmarkProperty',
    'interestRateConfigurationProperty',
    'liabilityAccountProperty',
    'linkedAccountProperty',
    'maximumPrefundingAmountProperty',
    'numberProperty',
    'overcollateralizationAmountProperty',
    'overcollateralizationMethodProperty',
    'percentageRateProperty',
    'portfolioCovenantProperty',
    'purchasePercentageRateProperty',
    'receivableAdvanceRateProperty',
    'receivableValuationRateProperty',
    'recurringDateProperty',
    'reportProperty',
    'reportTypeProperty',
    'structureProperty',
    'textProperty',
];
exports.PropertyType = {
    AutoApprovalProperty: 'autoApprovalProperty',
    AttachmentRateLimitProperty: 'attachmentRateLimitProperty',
    BankAccountTypeProperty: 'bankAccountTypeProperty',
    BooleanProperty: 'booleanProperty',
    CashAdvanceRateProperty: 'cashAdvanceRateProperty',
    ClassAllocationMethodProperty: 'classAllocationMethodProperty',
    ClassLabelProperty: 'classLabelProperty',
    CommitmentAmountConfigurationProperty: 'commitmentAmountConfigurationProperty',
    ConcentrationLimitProperty: 'concentrationLimitProperty',
    CurrencyProperty: 'currencyProperty',
    DateProperty: 'dateProperty',
    DeliverableReportProperty: 'deliverableReportProperty', // @jendevelops deliverableV2 deprecated
    DeliverableProperty: 'deliverableProperty',
    EligibilityTestProperty: 'eligibilityTestProperty',
    FinancialCovenantProperty: 'financialCovenantProperty',
    FrequencyPeriodProperty: 'frequencyPeriodProperty',
    FrequencyProperty: 'frequencyProperty',
    InterestRateBenchmarkProperty: 'interestRateBenchmarkProperty',
    InterestRateConfigurationProperty: 'interestRateConfigurationProperty',
    LiabilityAccountProperty: 'liabilityAccountProperty',
    LinkedAccountProperty: 'linkedAccountProperty',
    MaximumPrefundingAmountProperty: 'maximumPrefundingAmountProperty',
    NumberProperty: 'numberProperty',
    OvercollateralizationAmountProperty: 'overcollateralizationAmountProperty',
    OvercollateralizationMethodProperty: 'overcollateralizationMethodProperty',
    PercentageRateProperty: 'percentageRateProperty',
    PortfolioCovenantProperty: 'portfolioCovenantProperty',
    PurchasePercentageRateProperty: 'purchasePercentageRateProperty',
    ReceivableAdvanceRateProperty: 'receivableAdvanceRateProperty',
    ReceivableValuationRateProperty: 'receivableValuationRateProperty',
    RecurringDateProperty: 'recurringDateProperty',
    ReportProperty: 'reportProperty',
    ReportTypeProperty: 'reportTypeProperty',
    StructureProperty: 'structureProperty',
    TextProperty: 'textProperty',
};
const PropertyValueSchema = z.union([
    Bank.AccountTypeSchema,
    z.enum(CreditFacility.ClassLabel),
    z.string(),
    z.number(),
    z.boolean(),
    Utils.ZodFullDateStrLightWeightStruct,
    z.enum(Report.ReportTypeIterable),
    z.enum(Bank.InterestRateBenchmark),
    z.enum(CreditFacility.CreditFacilityStructureType),
    z.enum(Deliverable.v3DEPRECATED.DeliverableValueTypes),
    z.enum(Utils.FrequencyPeriodIterable),
]);
exports.BasePropertySchema = z.object({
    type: z.enum(exports.PropertyTypeIterable),
    name: z.string(), // free text, as named in specific credit agreement
    value: PropertyValueSchema,
    _isWrittenIn_: z.boolean(),
    section: z.optional(z.string()),
    description: z.optional(z.string()),
    _note_: z.optional(z.string()),
});
exports.BankAccountTypeSchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.BankAccountTypeProperty),
    value: Bank.AccountTypeSchema,
});
exports.BooleanPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.BooleanProperty),
    value: z.boolean(),
});
exports.CashAdvanceRatePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.CashAdvanceRateProperty),
    value: z.string(), // short description of cash advance rate
    _config_: z.object({
        cashAdvanceRateConfig: Config.CashAdvanceRate.ConfigSchema,
    }),
});
const ClassLabelPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.ClassLabelProperty),
    value: z.enum(CreditFacility.ClassLabel),
});
exports.CurrencyPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.CurrencyProperty),
    value: z.number(),
    currency: z.enum(Bank.Currency),
});
exports.DatePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.DateProperty),
    value: Utils.ZodFullDateStrLightWeightStruct,
});
exports.RecurringDatePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.RecurringDateProperty),
    value: z.string(), // simple description if wanting to render
    _config_: z.object({
        recurringDateConfig: Date.RecurringDate.ConfigSchema,
    }),
});
exports.CommitmentAmountConfigurationPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.CommitmentAmountConfigurationProperty),
    value: z.string(), // Set value with string description based on configuration
    currency: z.enum(Bank.Currency),
    amounts: z.array(Config.CommitmentAmount.ConfigSchema),
});
// DEPRECATED namespace moved to ./DEPRECATED.ts
// Re-exported via index.ts as `export * as DEPRECATED from './DEPRECATED'`
exports.DeliverableArtifactPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.DeliverableProperty),
    value: z.string(),
    reportingPeriod: Date.Reporting.ReportingPeriodSchema,
    _config_: Config.DeliverableArtifactProperty.ConfigSchema,
});
exports.DeliverablePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.DeliverableProperty),
    value: z.string(),
    containerType: z.enum(Deliverable.DeliverableContainerTypes),
    reportingPeriod: Date.Reporting.ReportingPeriodSchema,
    finalArtifacts: z.array(exports.DeliverableArtifactPropertySchema),
    dependencies: z.array(exports.DeliverableArtifactPropertySchema),
    _config_: Config.DeliverableProperty.ConfigSchema,
});
/**
 * when extending a new type from this definition, please add its allowed values in the corresponding FE component via
 * helper function getSelectOptionsForFrequencyPeriodProperty. this enables the FE to show only the valid select options
 * for each specific type.
 */
const FrequencyPeriodPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.FrequencyPeriodProperty),
    value: z.enum(Utils.FrequencyPeriodIterable),
});
const InterestRateBenchmarkFrequencyPeriodPropertySchema = FrequencyPeriodPropertySchema.extend({
    value: z.union([
        z.literal(Utils.FrequencyPeriod.Day),
        z.literal(Utils.FrequencyPeriod.Month),
    ]),
});
const DrawRequestMaximumAmountFrequencyPeriodPropertySchema = FrequencyPeriodPropertySchema.extend({
    value: z.union([
        z.literal(Utils.FrequencyPeriod.Week),
        z.literal(Utils.FrequencyPeriod.Month),
    ]),
});
const FrequencyPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.FrequencyProperty),
    value: z.number(),
    frequencyPeriod: z.enum(Utils.FrequencyPeriodIterable),
    frequencyType: z.enum(Utils.FrequencyType),
});
const MaximumFrequencyPropertySchema = FrequencyPropertySchema.extend({
    frequencyPeriod: z.enum(Utils.FrequencyPeriodIterable),
    frequencyType: z.literal(Utils.FrequencyType.Calendar),
});
const MaximumPrefundingAmountPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.MaximumPrefundingAmountProperty),
    value: z.string(), // short description
    _config_: z.object({
        maximumPrefundingAmountConfig: Config.MaximumPrefundingAmount.ConfigSchema,
    }),
});
const InterestRateBenchmarkPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.InterestRateBenchmarkProperty),
    value: z.enum(Bank.InterestRateBenchmark),
});
exports.NumberPropertyUnitIterable = [
    'day',
    'businessDay',
    'hour24',
    'hour',
];
exports.NumberPropertyUnit = {
    Day: 'day',
    BusinessDay: 'businessDay',
    Hour24: 'hour24',
    Hour: 'hour',
};
const NumberPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.NumberProperty),
    value: z.number(),
    unit: z.enum(exports.NumberPropertyUnitIterable),
});
exports.PercentageRatePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.PercentageRateProperty),
    value: z.number(),
});
exports.AttachmentRateLimitPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.AttachmentRateLimitProperty),
    /**
     * Represent property description but currently is not in use.
     * We don't expose this for the user to update or utilize.
     * Currently just setting it to the used formula by default
     */
    value: z.string(),
    // Can extend this to multiple interfaces as needed
    _config_: z.object({
        type: z.literal('formula'),
        config: Config.FullFormulaConfigSchema,
    }),
});
const ReportTypeSchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.ReportTypeProperty),
    value: Report.ReportTypeSchema,
});
exports.StructurePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.StructureProperty),
    value: z.enum(CreditFacility.CreditFacilityStructureType),
});
exports.TextPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.TextProperty),
    value: z.string(),
});
// @jendevelops deliverables-deprecated
// Defined here (instead of DEPRECATED.ts) to avoid circular dependency
// Re-exported from DEPRECATED module for backward compatibility
exports.DeliverableReportPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.DeliverableReportProperty),
    value: Report.ReportTypeSchema,
    _config_: Config.DeliverableReportProperty.ConfigSchema,
});
const ClassAllocationMethodPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.ClassAllocationMethodProperty),
    value: z.union([
        z.enum(FundingRequest.ClassDrawRequestAllocationMethods),
        z.enum(FundingRequest.ClassCurePaydownAllocationMethods),
        z.enum(FundingRequest.ClassCollectionsPaydownAllocationMethods),
    ]),
});
// Zod schema for EligibilityTestProperty
exports.EligibilityTestPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.EligibilityTestProperty),
    value: z.string(),
    criteriaNumber: z.string(),
    _config_: z.object({
        eligibilityTestConfig: Config.EligibilityTest.ConfigSchema.optional(),
    }),
});
// Zod schemas for rate properties
exports.ReceivableAdvanceRatePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.ReceivableAdvanceRateProperty),
    value: z.string(),
    _config_: z.object({
        receivableAdvanceRateConfig: Config.ReceivableAdvanceRate.ConfigSchema,
    }),
});
exports.ReceivableValuationRatePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.ReceivableValuationRateProperty),
    value: z.string(),
    _config_: z.object({
        receivableValuationRateConfig: Config.ReceivableValuationRate.ConfigSchema,
    }),
});
exports.PurchasePercentageRatePropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.PurchasePercentageRateProperty),
    value: z.string(),
    _config_: z.object({
        purchasePercentageRateConfig: Config.PurchasePercentageRate.ConfigSchema,
    }),
});
// ********************************************************
//                  FINANCIAL COVENANT
// ********************************************************
const BaseFinancialCovenantLimitSchema = z.object({
    value: z.number(),
    valueType: z.enum(Config.FinancialCovenant.LimitValueTypeIterable),
});
const FinancialCovenantCurrencyLimitSchema = BaseFinancialCovenantLimitSchema.extend({
    valueType: z.literal(Config.FinancialCovenant.LimitValueType.currency),
    currency: z.enum(Bank.Currency),
});
const FinancialCovenantRatioLimitSchema = BaseFinancialCovenantLimitSchema.extend({
    valueType: z.literal(Config.FinancialCovenant.LimitValueType.ratio),
});
const FinancialCovenantPercentageLimitSchema = BaseFinancialCovenantLimitSchema.extend({
    valueType: z.literal(Config.FinancialCovenant.LimitValueType.percentage),
});
const FinancialCovenantLimitSchema = z.union([
    FinancialCovenantCurrencyLimitSchema,
    FinancialCovenantRatioLimitSchema,
    FinancialCovenantPercentageLimitSchema,
]);
// Zod schema for FinancialCovenantProperty
exports.FinancialCovenantPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.FinancialCovenantProperty),
    covenantKey: z.string(),
    limit: FinancialCovenantLimitSchema,
    limitType: z.nativeEnum(Config.FinancialCovenant.LimitType),
    value: z.string(),
    _config_: Config.FinancialCovenant.ConfigSchema.optional(),
});
// ********************************************************
//                  PORTFOLIO COVENANT
// ********************************************************
// Zod schema for PortfolioCovenantProperty
exports.PortfolioCovenantPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.PortfolioCovenantProperty),
    covenantKey: z.string(),
    value: z.string(),
    _config_: Config.PortfolioCovenant.ConfigSchema.optional(),
});
exports.ConcentrationLimitPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.ConcentrationLimitProperty),
    value: z.string(),
    criteriaNumber: z.string(),
    _config_: z.object({
        concentrationLimitConfig: Config.ConcentrationLimit.SourceConfigSchema.optional(),
    }),
});
// Note: below should align with "Report.ReportType" directly.
// If enough supported reports overlap, can consider merging / utilizing single source
exports.ReportConfigTypeIterable = [
    'assetVerification',
    'batchSettlement',
    'borrowingBaseServicerReport',
    'borrowingBaseCertificate',
    'backupServicingCertificate',
    'disbursementNotice',
    'fundingNotice',
    'fundingRequestServicerReport',
    'invoice',
    'monthlyServicerReport',
    'noticeOfBorrowing',
    'noticeOfPrepayment',
    'paymentInKindNotice',
    'receivableResponseTapePreviewServicerReport',
    'receivablesSaleAgreement',
    'releaseNotice',
    'facilityTrialBalance',
    'loanTrialBalance',
];
// Zod schema for ReportingProperty
exports.ReportingPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.ReportProperty),
    name: z.string(),
    value: z.string(),
    reportConfigTypes: z.array(z.enum(exports.ReportConfigTypeIterable)),
    _config_: Config.Reporting.ConfigSchema,
});
// Zod schema for ReportingMechanics (array of ReportingProperty)
exports.ReportingMechanicsSchema = z.array(exports.ReportingPropertySchema);
exports.LinkedAccountPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.LinkedAccountProperty),
    value: z.string(), // bank account id
});
exports.PropertyContainerTypeIterable = [
    'deliverableReportPropertyContainer',
    'linkedAccountPropertyContainer',
    'reportTypePropertyContainer',
    'textPropertyContainer',
];
exports.PropertyContainerType = {
    DeliverableReportPropertyContainer: 'deliverableReportPropertyContainer',
    LinkedAccountPropertyContainer: 'linkedAccountPropertyContainer',
    ReportTypePropertyContainer: 'reportTypePropertyContainer',
    TextPropertyContainer: 'textPropertyContainer',
};
const PropertyContainerContentsSchema = z.union([
    z.array(exports.DeliverableReportPropertySchema), // @jendevelops deliverables-deprecated
    z.array(exports.LinkedAccountPropertySchema),
    z.array(ReportTypeSchema),
    z.array(exports.TextPropertySchema),
]);
exports.BasePropertyContainerSchema = z.object({
    type: z.enum(exports.PropertyContainerTypeIterable),
    name: z.string(), // free text, as named in specific credit agreement
    contents: PropertyContainerContentsSchema,
    _isWrittenIn_: z.boolean(),
    section: z.optional(z.string()),
    description: z.optional(z.string()),
    _note_: z.optional(z.string()),
});
// @jendevelops deliverables-deprecated
const DeliverablePropertyContainerSchema = exports.BasePropertyContainerSchema.extend({
    type: z.literal(exports.PropertyContainerType.DeliverableReportPropertyContainer),
    contents: z.array(exports.DeliverableReportPropertySchema), // required documents
    deliverableType: z.enum(Deliverable.v3DEPRECATED.DeliverableType),
    frequency: z.enum(Utils.FrequencyPeriodIterable),
    dueDates: z.array(Utils.ZodFullDateStrStruct),
});
const LinkedAccountPropertyContainerSchema = exports.BasePropertyContainerSchema.extend({
    type: z.literal(exports.PropertyContainerType.LinkedAccountPropertyContainer),
    contents: z.array(exports.LinkedAccountPropertySchema),
});
const ReportTypePropertyContainerSchema = exports.BasePropertyContainerSchema.extend({
    type: z.literal(exports.PropertyContainerType.ReportTypePropertyContainer),
    contents: z.array(ReportTypeSchema),
});
exports.OvercollateralizationAmountPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.OvercollateralizationAmountProperty),
    value: z.number(),
    valueType: z.literal('percent'), // To be extended if desired, but unlikely at this time
});
// ======== ZOD SCHEMAS FOR CALC AGENT MECHANICS ========
// LoanProductMechanics schema
exports.LoanProductMechanicsSchema = z.object({
    _id_: z.string(),
    eligibilityTests: z.array(exports.EligibilityTestPropertySchema),
    concentrationLimits: z.array(exports.ConcentrationLimitPropertySchema),
    receivableValuationRate: exports.ReceivableValuationRatePropertySchema,
    receivableAdvanceRate: exports.ReceivableAdvanceRatePropertySchema,
    purchasePercentageRate: exports.PurchasePercentageRatePropertySchema,
    _config_: Config.LoanProductMechanics.ConfigSchema,
});
// MultiLoanProductConcentrationLimit schema
exports.MultiLoanProductConcentrationLimitSchema = exports.ConcentrationLimitPropertySchema.extend({
    loanProducts: z.array(z.object({ _id_: z.string() })),
});
// CalcAgentMechanics schema - Wire schema for JSON schema generation
exports.CalcAgentMechanicsWireSchema = z.object({
    _artifactDocumentId_: z.string().optional(),
    loanProductMechanics: z.array(exports.LoanProductMechanicsSchema),
    multiLoanProductConcentrationLimits: z.array(exports.MultiLoanProductConcentrationLimitSchema),
    _config_: Config.ResolvedCalcAgentMechanicsConfigSchema,
});
// items
// orgType should eventually be consolidated into partyType
// ======== SUB-CATEGORIES ========
// ======== FUNDING REQUEST COMPONENT ========
exports.AutoApprovalStrategyIterable = [
    'specificHour',
    'withDelay',
    'immediate',
];
exports.AutoApprovalStrategy = {
    SpecificHour: 'specificHour',
    WithDelay: 'withDelay',
    Immediate: 'immediate',
};
const AutoApprovalPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.AutoApprovalProperty),
    approvalStrategy: z.enum(exports.AutoApprovalStrategyIterable),
    value: z.number(),
    unit: z.optional(z.enum(exports.NumberPropertyUnitIterable)),
});
exports.OvercollateralizationMethodIterable = ['classSubordination'];
exports.OvercollateralizationMethod = {
    ClassSubordination: 'classSubordination',
};
const OvercollateralizationMethodPropertySchema = exports.BasePropertySchema.extend({
    type: z.literal(exports.PropertyType.OvercollateralizationMethodProperty),
    value: z.enum(exports.OvercollateralizationMethodIterable),
});
const FundingRequestComponentBasePropertiesSchema = z.object({
    // optional properties
    minimumAmount: z.optional(exports.CurrencyPropertySchema),
    incrementAmount: z.optional(exports.CurrencyPropertySchema),
    maximumFrequency: z.optional(MaximumFrequencyPropertySchema),
    submissionNoticePeriod: z.optional(NumberPropertySchema),
    requiredDocumentation: z.optional(ReportTypePropertyContainerSchema),
    sourceAccounts: z.optional(LinkedAccountPropertyContainerSchema),
    destinationAccounts: z.optional(LinkedAccountPropertyContainerSchema),
});
// ======== CATEGORIES ========
const BaseBorrowingBaseMechanicsSchema = z.object({
    // optional properties
    reportingDateDescription: z.optional(exports.TextPropertySchema),
    concentrationLimitTransitionDate: z.optional(exports.DatePropertySchema),
});
exports.BaseFacilityMechanicsSchema = z.object({
    // mandatory properties
    closingDate: exports.DatePropertySchema,
    finalMaturityDate: exports.DatePropertySchema,
    structure: exports.StructurePropertySchema,
    // optional properties
    amortizationPeriodStart: z.optional(exports.DatePropertySchema),
    amortizationPeriodEnd: z.optional(exports.DatePropertySchema),
    callProtectionExpirationDate: z.optional(exports.DatePropertySchema),
    callProtectionValue: z.optional(exports.PercentageRatePropertySchema),
    commitmentPeriodEffectiveDate: z.optional(exports.DatePropertySchema),
    externalFacilityId: z.optional(exports.TextPropertySchema),
    governingLaw: z.optional(exports.TextPropertySchema),
    interestRateCeiling: z.optional(exports.PercentageRatePropertySchema),
    minimumUtilization: z.optional(exports.PercentageRatePropertySchema),
    revolvingCommitmentTermination: z.optional(exports.DatePropertySchema),
    seniority: z.optional(exports.TextPropertySchema),
    yieldMaintenance: z.optional(exports.DatePropertySchema),
});
exports.CreditAgreementSchemaVersionIterable = ['1.0'];
exports.CreditAgreementSchemaVersion = {
    '1.0': '1.0',
};
exports.CreditAgreementMetadataSchema = z.object({
    id: z.string(),
    facilityType: z.enum(DbTables_1.FacilityTypeIterable),
    creditFacilityId: z.string(),
    effectiveFrom: z.number(),
    effectiveTo: z.number(),
    version: z.string(), // CreditAgreementAmendment.InternalModification
    _schemaVersion_: z.string(), // MajorBreakingChange.MinorPatch
    s3Path: z.optional(z.string()),
    _note_: z.optional(z.string()),
    // WIP only property that points to current CA id
    // WIPs can only be committed against this credit agreement id to
    // ensure serial commits
    _currentCreditAgreementId_: z.optional(z.string()),
});
exports.creditAgreementSourceDocumentMetadataKeys = [
    'id',
    'facilityType',
    'creditFacilityId',
    'effectiveFrom',
    'effectiveTo',
    'version',
    '_schemaVersion_',
    's3Path',
    '_note_',
    '_currentCreditAgreementId_',
];
// ======== WIRE SCHEMAS FOR JSON SCHEMA GENERATION ========
// These Wire schemas use z.any() for complex nested types that would be
// too complex to fully model in Zod. They are used for JSON schema generation
// (Python codegen) while the TypeScript types remain authoritative for runtime.
// CreditAgreementNonEntityCategories Wire schema
// Note: Using z.any() for property schemas that transitively use z.custom() types
// (e.g., ZodFullDateStrForJsonSchemaStruct in Reporting.Inputs.Config)
const CreditAgreementNonEntityCategoriesWireSchema = z.object({
    fundingRequestMechanics: z.any(), // FundingRequestMechanics - complex nested type
    settlementMechanics: z.any(), // SettlementMechanics - complex nested type
    financialCovenants: z.array(z.any()), // FinancialCovenantProperty[]
    portfolioCovenants: z.array(z.any()), // PortfolioCovenantProperty[]
    liabilityAccounts: z.array(z.any()).optional(), // LiabilityAccountProperty[]
    reportingMechanics: z.array(z.any()), // ReportingMechanics (ReportingProperty[])
});
// CreditAgreementBaseCategories Wire schema
const CreditAgreementBaseCategoriesWireSchema = CreditAgreementNonEntityCategoriesWireSchema.extend({
    facilityMechanics: z.any(), // FacilityMechanics - complex nested type with parties
    borrowingBaseMechanics: z.any(), // BorrowingBaseMechanics - includes CalcAgentMechanics
    classMechanics: z.any().optional(), // ClassMechanics
    loanMechanicsV1: z.any().optional(), // Funding.LoanMechanicsWithItems
    reportingDeliverables: z.array(z.any()), // DEPRECATED.DeliverableProperty[]
    deliverables: z.array(z.any()), // DeliverableProperty[]
});
// CreditAgreementDocument Wire schema
exports.CreditAgreementDocumentWireSchema = exports.CreditAgreementMetadataSchema.merge(CreditAgreementBaseCategoriesWireSchema);
// CreditAgreementBaseCategoriesWithEntities Wire schema (for FullArtifact)
const CreditAgreementBaseCategoriesWithEntitiesWireSchema = CreditAgreementNonEntityCategoriesWireSchema.extend({
    facilityMechanics: z.any(), // FacilityMechanicsWithEntities
    borrowingBaseMechanics: z.any(), // BorrowingBaseMechanicsWithEntities
    classMechanics: z.any().optional(), // ClassMechanicsWithEntities
    loanMechanicsV1: z.any().optional(), // Funding.LoanMechanicsWithEntities
    reportingDeliverables: z.array(z.any()), // DEPRECATED.DeliverablePropertyWithEntities[]
    deliverables: z.array(z.any()), // DeliverableProperty[]
});
// CreditAgreementFullArtifact Wire schema
exports.CreditAgreementFullArtifactWireSchema = exports.CreditAgreementMetadataSchema.merge(CreditAgreementBaseCategoriesWithEntitiesWireSchema);
// CreditAgreementArtifact Wire schema
// Note: This type uses ToArtifactType<> mapped types which strip _property_ fields.
// For Wire schema, we use a simplified structure with z.any() for complex nested types.
exports.CreditAgreementArtifactWireSchema = exports.CreditAgreementMetadataSchema.extend({
    fundingRequestMechanics: z.any(),
    settlementMechanics: z.any(),
    financialCovenants: z.array(z.any()), // ToArtifactType<FinancialCovenantProperty[]>
    portfolioCovenants: z.array(z.any()), // ToArtifactType<PortfolioCovenantProperty[]>
    classMechanics: z.any().optional(),
    liabilityAccounts: z.array(z.any()).optional(),
    reportingDeliverables: z.array(z.any()),
    deliverables: z.array(z.any()),
    facilityMechanics: z.any(), // FacilityMechanicsArtifactType
    borrowingBaseMechanics: z.any(), // BorrowingBaseMechanicsArtifactType
});
//# sourceMappingURL=DomainEntity.js.map